import React, {useEffect} from "react";
import {observer} from "mobx-react";
import styled from "@emotion/styled";
import {Typography, Stack} from "@mui/material";
import {Exist} from "views/components/exist/exist.component";
import {IMatch} from "data/types/entities";
import {MatchUtils} from "data/utils/match";
import {useViewController} from "data/services/locator";
import {IMatchStatusController} from "views/components/match_status/match_status.controller";
import {Bindings} from "data/constants/bindings";

const LiveChip = styled.div`
	color: #fff;
	display: flex;
	align-items: center;
	padding: 4px 6px;
	background: #ff0000;
	border-radius: 8px;
	font-size: 8px;
	line-height: 8px;
	font-family: var(--fontFamilyBase);
	font-weight: 800;
`;

const Wrapper = styled(Stack)`
	flex-flow: row;
	justify-content: space-between;
	width: 100%;
	align-items: center;
`;

const Clock = styled(Typography)`
	text-transform: uppercase;
	@media (max-width: 768px) {
		font-size: 12px;
	}
`;
interface IProps {
	match: IMatch;
}

export const MatchStatus: React.FC<IProps> = observer(({match}) => {
	const controller = useViewController<IMatchStatusController>(Bindings.MatchStatusController);

	useEffect(() => {
		if (match) {
			controller.setMatch(match);
		}
	}, [controller, match]);

	return (
		<Wrapper>
			<Exist when={MatchUtils.isPlaying(match)}>
				<LiveChip>• {controller.i18n.t("widget.match.live", "LIVE")}</LiveChip>
				<Clock variant={"subtitle1"}>
					{match.clock} - {controller.getPeriodName}
				</Clock>
			</Exist>

			<Exist when={!MatchUtils.isPlaying(match)}>
				<Clock variant={"subtitle1"}>{controller.getDate}</Clock>
				<Clock variant={"subtitle2"}>{controller.getPeriodName}</Clock>
			</Exist>
		</Wrapper>
	);
});
